import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isValidCPF, isValidPhone } from '@brazilian-utils/brazilian-utils';
import UpdateUser from '../../components/organisms/updateUser';
import { SessionContext } from '../StoreProvider';
import { assign as navigate } from '../../routes';

const UpdateUserContainer = ({ user, updateUserData, setUserCpf }) => {
  const [cpf, setCpf] = useState('');
  const [cpfValid, setCpfValid] = useState(false);
  const [mobilePhone, setMobilePhone] = useState('');
  const [mobilePhoneValid, setMobilePhoneValid] = useState(false);
  const [errorCpf, setErrorCpf] = useState('');
  const [errorMobilePhone, setErrorMobilePhone] = useState('');
  const [errorGeneric, setErrorGeneric] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const parseCpf = cpfNumber => cpfNumber.replace(/([.-])/g, '');
  const parseMobilePhone = mobilePhoneNumber =>
    mobilePhoneNumber.replace(/([().-\s])/g, '');

  const customValidationCPF = cpfValue => {
    const cpfNumber = parseCpf(cpfValue);
    if (isValidCPF(cpfNumber)) {
      setErrorCpf('');
      setCpfValid(true);
    }
    if (!isValidCPF(cpfNumber)) {
      setErrorCpf('CPF inválido');
      setDisabled(true);
      setCpfValid(false);
    }
  };
  const customValidationPhone = phoneValue => {
    if (isValidPhone(phoneValue)) {
      setErrorMobilePhone('');
      setMobilePhoneValid(true);
    }
    if (!isValidPhone(phoneValue)) {
      setErrorMobilePhone('Telefone inválido');
      setDisabled(true);
      setMobilePhoneValid(false);
    }
  };

  useEffect(() => {
    if (cpfValid && mobilePhoneValid) {
      setDisabled(false);
    }
  }, [cpfValid, mobilePhoneValid]);

  const submitForm = event => {
    event.preventDefault();

    // start button loader and set disable to true to avoid multiple clicks
    setLoading(true);
    setDisabled(true);
    setUserCpf(cpf);

    // check if the cpf field is empty
    if (cpf === '') {
      setErrorCpf('Preencha seu CPF');
      return;
    }

    // check if the mobilePhone field is empty
    if (mobilePhone === '') {
      setErrorMobilePhone('Preencha seu telefone');
      return;
    }

    // Remove special characters from cpf
    const cpfNumber = parseCpf(cpf);
    const mobilePhoneNumber = parseMobilePhone(mobilePhone);

    if (isValidCPF(cpfNumber) && isValidPhone(mobilePhoneNumber)) {
      updateUserData(
        user.userData.id,
        user,
        mobilePhoneNumber,
        cpfNumber,
        () => {
          navigate('/ativacao');
        },
        CPFexists => {
          setLoading(false);
          setDisabled(false);
          if (CPFexists) {
            navigate('/confirmar-cpf/erro');
          } else {
            setErrorGeneric(
              'Parece que ocorreu um erro inesperado. Por favor, tente novamente.'
            );
          }
        }
      );
    }
  };
  return (
    <div className="confirm-cpf-container">
      <UpdateUser
        cpf={cpf}
        setCpf={setCpf}
        mobilePhone={mobilePhone}
        setMobilePhone={setMobilePhone}
        submitForm={submitForm}
        errorCpf={errorCpf}
        errorMobilePhone={errorMobilePhone}
        errorGeneric={errorGeneric}
        disabled={disabled}
        loading={loading}
        customValidationCPF={customValidationCPF}
        customValidationPhone={customValidationPhone}
      />
    </div>
  );
};

UpdateUserContainer.defaultProps = {
  user: {}
};

UpdateUserContainer.propTypes = {
  user: PropTypes.shape({
    subscriber: PropTypes.bool,
    userData: PropTypes.object
  }),
  updateUserData: PropTypes.func.isRequired,
  setUserCpf: PropTypes.func.isRequired
};

export default props => (
  <UpdateUserContainer {...useContext(SessionContext)} {...props} />
);
